
import { Component, Vue } from "vue-property-decorator";
import UserDetailHeader from "@/components/user-detail/user-detail-header/UserDetailHeader.vue";
import UserDetailTab from "@/components/user-detail/user-detail-tab/UserDetailTab.vue";
import UserDetailNav from "@/components/user-detail/user-detail-nav/UserDetailNav.vue";
import UserDetailGroup from "@/components/user-detail/user-detail-group/UserDetailGroup.vue";
import UserDetailInfo from "@/components/user-detail/user-detail-info/UserDetailInfo.vue";
import UserDetailMachinesTab from "@/components/user-detail/user-detail-machines-tab/UserDetailMachinesTab.vue";
import { User, UserStatus } from "@/entities";
import UserGridAlert from "@/components/users/user-grid-alert/UserGridAlert.vue";
import { AssignedServicePoint } from "@/entities/assignedServicePoint";

@Component({
  components: {
    UserDetailHeader,
    UserDetailTab,
    UserDetailNav,
    UserDetailGroup,
    UserDetailInfo,
    UserDetailMachinesTab,
    UserGridAlert,
  },
})
export class UserPage extends Vue {
  user!: User;
  assignedServicePoints: AssignedServicePoint[] = [];
  userId!: string;
  loaded = false;
  update = false;
  firstLoad = true;

  created(): void {
    this.userId = this.$route.params.id;
  }

  mounted(): void {
    this.fetchUserCustomer();
  }

  fetchUserCustomer(): void {
    this.$services.user
      .fetchUserCustomer(this.userId)
      .then((res: User) => {
        if (res) {
          this.loaded = true;
          this.user = res;
          this.update = !this.update;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async onRefresh(callback: Function): Promise<void> {
    await this.fetchUserCustomerServicepoints();
    if (typeof callback === "function") {
      callback();
    }
  }

  async fetchUserCustomerServicepoints(): Promise<void> {
    const res = await this.$services.user.fetchUserCustomerServicepoints(this.userId);
    if (res) {
      this.firstLoad = false;
      this.assignedServicePoints = res.assignedServicePoints;
    }
  }

  isActive(item: User): boolean {
    if (!item.active) return false;
    return item.status !== UserStatus.PENDING;
  }

  onTabSelected(tab: string) {
    if (tab === "machines" && this.firstLoad) {
      this.fetchUserCustomerServicepoints();
    }
  }
}

export default UserPage;
